import { useContext } from 'react';
import { SearchContext } from '../context/searchText';

const SearchInPageInput = () => {
    const {searchTerm, changeSearch} = useContext(SearchContext);

    const change = (e: any) => {
        const val: string = e.target.value;
        changeSearch(val);
    }
    return (
        <input value={searchTerm} onChange={change} placeholder={"Search..."} />
    );
}

export default SearchInPageInput;
